import styled from 'styled-components'
import { ValueDisplay as ValueDisplayBase } from 'components/form/field/s'

export const ValueDisplay = styled(ValueDisplayBase)`
    height: auto;
`